module.exports = __webpack_public_path__ + "static/media/database.82a6d912.svg";